import { ReactNode } from "react";

import { invoiceUrl } from "@pages/AdminDashboard/externalLinks";
import { ExternalLink } from "@pages/AdminDashboard/ui/DataTable/cells";

interface InvoiceLinkProps {
  invoiceId?: string | null;
  children: ReactNode;
}

// Text that opens an invoice at the payment vendor its ID names, or stays text when the row has
// no invoice or its ID names no vendor (XCUT-R26, R27, R32, R33).
export const InvoiceLink = ({ invoiceId, children }: InvoiceLinkProps) => {
  const url = invoiceUrl(invoiceId);
  if (!url) return <>{children}</>;

  return <ExternalLink href={url}>{children}</ExternalLink>;
};
